"use client";

import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import { safeT } from "@/utils/safeT";

interface VotingPeriodProps {
  startDate: string; // '20250412'
  endDate: string; // '20251012'
  label?: string;
  short?: boolean; // ✅ 추가: 짧은 포맷 여부
}

export default function VotingPeriod({
  startDate,
  endDate,
  label,
  short = true, // 기본값은 false (긴 형식)
}: VotingPeriodProps) {
  const [formatted, setFormatted] = useState<string | null>(null);
  const t = useTranslations();
  useEffect(() => {
    const parseDate = (yyyymmdd: string): Date => {
      const year = Number(yyyymmdd.slice(0, 4));
      const month = Number(yyyymmdd.slice(4, 6)) - 1;
      const day = Number(yyyymmdd.slice(6, 8));
      return new Date(year, month, day);
    };

    const formatDate = (date: Date): string => {
      return new Intl.DateTimeFormat(navigator.language, {
        year: short ? "2-digit" : "numeric",
        month: short ? "numeric" : "long",
        day: "numeric",
      }).format(date);
    };

    const start = parseDate(startDate);
    const end = parseDate(endDate);
    const result = `${formatDate(start)} ~ ${formatDate(end)}`;
    setFormatted(result);
  }, [startDate, endDate, short]);

  return (
    <Typography variant="body1" sx={{ minHeight: 24 }}>
      {formatted
        ? `${
            label
              ? label
              : safeT(t, "ui.label.votingPeriod", {
                  defaultMessage: "투표 기간",
                })
          }: ${formatted}`
        : " "}
    </Typography>
  );
}
